import { Alert, Button, DialogActions, DialogContent, DialogTitle } from "@mui/material"

export function AlertDialog({ message, title, ok, severity }) {
    return (
        <>
            {title && <DialogTitle data-cy="alert-dialog-title">{title}</DialogTitle>}
            <DialogContent sx={{ mt: 2 }} data-cy="alert-dialog-content">
                {severity ? <Alert severity={severity}>{message}</Alert> : message}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => ok(true)} color="primary" variant="contained" data-cy="alertOkButton">
                    Ok
                </Button>
            </DialogActions>
        </>
    )
}
